/* globals Drupal, $ */
import './full-vendor/designSystem/index'
import { setupStatusMessageCloseButtons } from './statusMessages'
import { runMegaMenuLoader } from './megaMenu'
import { setupMobileMenu } from './mobileMenu'
import { setupCarousels } from './uga-flickity'
import { activateHomeSlider } from './homepageSlider'
import { activateHomeStats } from './homepageStats'
import { setupSwiper } from './setupSwiper'
import { setupAccordions } from './paragraphs/accordion'
// import { runEventsApp } from './react/events'

let runCount = 0

function runOnlyOncePerPageLoad () {
  console.log('- RUNNING MAIN.JS -')
  // runEventsApp()
  runMegaMenuLoader()
  setupMobileMenu()
  activateHomeSlider()
  activateHomeStats()
  // setupCarousels()
  setupStatusMessageCloseButtons()
  setupSwiper()

  // paragraphs
  setupAccordions()
}

if (window && window.Drupal) {
  Drupal.behaviors.lawful = {
    attach: function (context, settings) {
      if (runCount === 0) {
        runOnlyOncePerPageLoad()
      }
      runCount++
    }
  }
} else {
  if (window) {
    window.addEventListener('load', (event) => {
      runOnlyOncePerPageLoad()
    })
  } else {
    console.log('No Window')
  }
}
